import Vue from 'vue';
import store from './../store';
import Api from './../api';

export default {
    isLogin(to, from, next) {
        // console.log('isLogin')
        var user = JSON.parse(localStorage.getItem('user', user));
        if (user) {
            if (user.roleId == 'admin' || user.roleId == 'super' || user.roleId == 'emp') {
                store.commit('set_user', user);
                return next('/wsc/manageform');
                // return next(from.path);
            } else {
                return next();
            }
        } else {
            return next();
        }
    },

    // isAuthAdmin(to, from, next) {
    //     // console.log('isAuthAdmin')
    //     var user = JSON.parse(localStorage.getItem('user', user));
    //     if(user!=null){
    //         var token = user.token;
    //         if(token!=undefined){
    //             Api.getAuth(token).then(res => {
    //                 var {data} = res;
    //                 var user = {
    //                     name: data.name,
    //                     roleId: data.roleId,
    //                     token: token
    //                 };

    //                 if (user) {
    //                     if (user.roleId == 'admin') {
    //                         localStorage.setItem('user', JSON.stringify(user));
    //                         store.commit('set_user', user);
    //                         return next();
    //                     } else {
    //                         return next(from.path);
    //                     }
    //                 } else {
    //                     localStorage.setItem('user', JSON.stringify(null));
    //                     store.commit('set_user', null);
    //                     return next('/login');
    //                 }

    //             }).catch(err => {
    //                 var {data} = err.response
    //                 // this.$swal(data.message, 'กรุณา Login ใหม่อีกครั้ง', "error");
    //                 alert(data.message+' กรุณา Login ใหม่อีกครั้ง');
    //                 localStorage.setItem('user', JSON.stringify(null));
    //                 store.commit('set_user', null);
    //                 return next('/login');
    //             })
    //         }else{
    //             return next('/login');
    //         }
    //     }else{
    //         return next('/login');
    //     }
    // },

    isAuth(to, from, next) {
        // console.log('isAuth')
        var user = JSON.parse(localStorage.getItem('user', user));
        if(user!=null){
            var token = user.token;
            if(token!=undefined){
                Api.getAuth(token).then(res => {
                    var {data} = res;
                    var user = {
                        companyId: data.result.company_id,
                        userId: data.result.id,
                        roleId: data.result.role_id,
                        name: data.result.name,
                        lastName: data.result.last_name,
                        token: token
                    };

                    if (user) {
                        if (user.roleId=='admin' || user.roleId=='super' || user.roleId=='emp') {
                            localStorage.setItem('user', JSON.stringify(user));
                            store.commit('set_user', user);
                            return next();
                        } else {
                            return next(from.path);
                        }
                    } else {
                        localStorage.setItem('user', JSON.stringify(null));
                        store.commit('set_user', null);
                        return next('/login');
                    }

                }).catch(err => {
                    var {data} = err.response
                    // this.$swal(data.message, 'กรุณา Login ใหม่อีกครั้ง', "error");
                    alert('กรุณา Login ใหม่อีกครั้ง');
                    localStorage.setItem('user', JSON.stringify(null));
                    store.commit('set_user', null);
                    return next('/login');
                })
            }else{
                return next('/login');
            }
        }else{
            return next('/login');
        }
    }
}
